import { useEffect, useState } from 'react';
import Container from '@mui/material/Container';
import { SpeakerComponent } from './SpeakersComponent';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGlobal } from '../../utils/GlobalContext';
import { session, newSession } from '../../data/session';
import { UserProfile, newUserProfile } from '../../data/userProfile';
import SpeakerInfoModal from '../common/SpeakerInfoModal';

export default function Speakers() {
    const [queryParameters,setSearchParams] = useSearchParams();
    const { state, dispatch } = useGlobal();
    const navigate = useNavigate();
    const [onLoad, setOnLoad] = useState(false);
    useEffect(() => {
        if(onLoad===false && state.Conference.Name!==""){
            handleSpeakerModalOpen(queryParameters.get("s")??"");
            queryParameters.delete('s');
            setSearchParams(queryParameters);
            setOnLoad(true);
        }
        if(state.Profiles.length && state.Profiles.length===0){
            return;
        }
        if (state.UserProfile.IsExistingUser === false && state.UserProfile.Id!=="") {
            navigate("/account");
        }
        if(onLoad === true && state.Conference.CurrentEventId==="" && queryParameters.get("s")!==null&&queryParameters.get("s")!==""){
            navigate(`/?s=${queryParameters.get("s")}`);
            setOnLoad(true);
        }else if (onLoad===true && state.Conference.CurrentEventId===""){
            navigate("/");
        }
    });

    // Speaker Modal Hookup
    const [speakerInfoOpen, setSpeakerInfoOpen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState<UserProfile>(newUserProfile());
    const handleSpeakerModalOpen = (speakerName: string) => {
        const tempSelectedSpeaker: UserProfile[] = state.Profiles.filter(function (el){
            return `${el.FirstName} ${el.LastName}`.toUpperCase()=== speakerName.toUpperCase();
        });
        //alert(tempSelectedSpeaker.length);
        if(tempSelectedSpeaker.length===0)
            return;
        setSelectedSpeaker(tempSelectedSpeaker[0]);
        setSpeakerInfoOpen(true);
    };
    const handleSpeakerModalClose = () => {
        setSpeakerInfoOpen(false);
    };
    return (
        <div className="container">
            <Container maxWidth="xl">
                <SpeakerComponent/>
            </Container>
            <SpeakerInfoModal show={speakerInfoOpen} onClose={handleSpeakerModalClose} speaker={selectedSpeaker}/>
        </div>
    )
}